import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from 'vuex-module-decorators'

@Module({
  name: 'ModalProcessPlaceChangeStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalProcessPlaceChangeStore extends BaseStore {
  _isOpen: boolean = false

  get isOpen(): boolean {
    return this._isOpen
  }

  @Mutation
  public open() {
    this._isOpen = true
  }

  @Mutation
  public close(): void {
    this._isOpen = false
  }
}
